import { OrganizationRoles } from 'src/enums'

export const orgRoleDisplayTitle = (role: OrganizationRoles): string => {
  return role === OrganizationRoles.owner
    ? 'Owner'
    : role === OrganizationRoles.admin
      ? 'Admin'
      : role === OrganizationRoles.bookkeeper
        ? 'Bookkeeper'
        : role === OrganizationRoles.cardManager
          ? 'Card Manager'
          : role === OrganizationRoles.member
            ? 'Member'
            : role === OrganizationRoles.guest
              ? 'Guest'
              : ''
}

export const orgRoleDisplayTitlePlural = (role: OrganizationRoles): string => {
  return role === OrganizationRoles.owner
    ? 'Owners'
    : role === OrganizationRoles.admin
      ? 'Admins'
      : role === OrganizationRoles.bookkeeper
        ? 'Bookkeepers'
        : role === OrganizationRoles.cardManager
          ? 'Card Managers'
          : role === OrganizationRoles.member
            ? 'Members'
            : role === OrganizationRoles.guest
              ? 'Guests'
              : ''
}

export const mapRoleToIndex = (
  role: OrganizationRoles | undefined,
  cardManagerRoleEnabled: boolean,
): number => {
  // TODO: remove second condition when card manager role is fully implemented
  if (cardManagerRoleEnabled) {
    switch (role) {
      case OrganizationRoles.member:
        return 0
      case OrganizationRoles.bookkeeper:
        return 1
      case OrganizationRoles.cardManager:
        return 2
      case OrganizationRoles.admin:
        return 3
      case OrganizationRoles.owner:
        return 4
      default:
        return -1
    }
  } else {
    switch (role) {
      case OrganizationRoles.member:
        return 0
      case OrganizationRoles.bookkeeper:
        return 1
      case OrganizationRoles.admin:
        return 2
      case OrganizationRoles.owner:
        return 3
      default:
        return -1
    }
  }
}

export const mapIndexToRole = (
  index: number,
  cardManagerRoleEnabled: boolean,
): OrganizationRoles | undefined => {
  // TODO: remove second condition when card manager role is fully implemented
  if (cardManagerRoleEnabled) {
    switch (index) {
      case 0:
        return OrganizationRoles.member
      case 1:
        return OrganizationRoles.bookkeeper
      case 2:
        return OrganizationRoles.cardManager
      case 3:
        return OrganizationRoles.admin
      case 4:
        return OrganizationRoles.owner
      default:
        return undefined
    }
  } else {
    switch (index) {
      case 0:
        return OrganizationRoles.member
      case 1:
        return OrganizationRoles.bookkeeper
      case 2:
        return OrganizationRoles.admin
      case 3:
        return OrganizationRoles.owner
      default:
        return undefined
    }
  }
}
